<template>
  <el-dialog
    title="新增菜单"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    :close-on-click-modal="false"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
      <!-- 父级菜单选择 -->
      <el-form-item label="父级菜单" prop="parent_id">
        <el-tree
          v-loading="treeLoading"
          :data="menuTree"
          :props="treeProps"
          node-key="id"
          default-expand-all
          highlight-current
          ref="menuTree"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="!data.id" style="color: #999; font-size: 12px; margin-left: 8px">(顶级菜单)</span>
          </span>
        </el-tree>
      </el-form-item>

      <!-- 菜单名称 -->
      <el-form-item label="菜单名称" prop="menu_name">
        <el-input v-model.trim="dataForm.menu_name" placeholder="请输入菜单名称"></el-input>
      </el-form-item>

      <!-- 菜单类型 -->
      <el-form-item label="菜单类型" prop="type">
        <el-radio-group v-model="dataForm.type">
          <el-radio :label="1">目录</el-radio>
          <el-radio :label="2">菜单</el-radio>
          <el-radio :label="3">按钮</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 排序 -->
      <el-form-item label="显示排序" prop="display_order">
        <el-input-number
          v-model="dataForm.display_order"
          :min="0"
          :max="999"
          placeholder="排序值越小越靠前"
          style="width: 100%"
        />
      </el-form-item>

      <!-- 路由路径（菜单类型必填） -->
      <el-form-item
        label="路由路径"
        prop="url_path"
        :rules="[
          { required: dataForm.type === 2, message: '菜单类型必须填写路由路径', trigger: 'blur' }
        ]"
      >
        <el-input
          v-model.trim="dataForm.url_path"
          placeholder="如：/system/user，菜单类型必填"
        />
      </el-form-item>

      <!-- 权限标识（目录和按钮类型必填） -->
      <el-form-item
        label="权限标识"
        prop="perms"
        :rules="[
          { required: dataForm.type === 1 || dataForm.type === 3, message: '目录和按钮类型必须填写权限标识', trigger: 'blur' }
        ]"
      >
        <el-input
          v-model.trim="dataForm.perms"
          placeholder="如：system:user:add，目录和按钮类型必填"
        />
      </el-form-item>

      <!-- 状态 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 显示状态 -->
      <el-form-item label="显示状态" prop="visible">
        <el-radio-group v-model="dataForm.visible">
          <el-radio :label="0">显示</el-radio>
          <el-radio :label="1">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注信息" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          v-model="dataForm.remark"
          placeholder="请输入备注信息"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateMenu',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      treeLoading: false, // 添加树加载状态

      // 表单数据
      dataForm: {
        parent_id: null,        // 父级ID，null 表示顶级
        menu_name: null,
        type: 2,                // 默认为菜单
        display_order: 0,
        url_path: null,
        perms: null,
        status: 0,
        visible: 0,
        remark: null
      },

      // 校验规则
      dataRule: {
        menu_name: [
          { required: true, message: '菜单名称不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择菜单类型', trigger: 'change' }
        ],
        display_order: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      },

      // 菜单树数据（用于父级选择）
      menuTree: [],
      treeProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  created() {
    this.loadMenuTree();
  },
  methods: {
    // 加载菜单树用于选择父级
    loadMenuTree() {
      this.treeLoading = true;
      return new Promise((resolve, reject) => {
        this.$axios
          .get('/api-30216/api/menu/tree')
          .then(res => {
            const data = res.data || [];
            this.menuTree = [
              {
                id: null,
                name: '顶级菜单',
                isRoot: true,
                children: Array.isArray(data) ? data : []
              }
            ];
            resolve();
          })
          .catch(err => {
            this.$message.error('无法加载菜单结构');
            this.menuTree = [];
            reject(err);
          })
          .finally(() => {
            this.treeLoading = false;
          });
      });
    },

    // 打开弹窗（可传入 parent_id 预选中）
    openDialog(parentId = null) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        // 重置表单
        this.$refs.dataForm.resetFields();

        // === 关键修改：每次打开都重新加载菜单树 ===
        this.loadMenuTree().then(() => {
          // 树加载完成后，再尝试选中指定节点
          if (parentId !== null) {
            this.dataForm.parent_id = parentId;
            this.$nextTick(() => {
              this.$refs.menuTree.setCurrentKey(parentId);
            });
          } else {
            this.dataForm.parent_id = null;
            this.$refs.menuTree.setCurrentKey(null);
          }
        });
      });
    },

    // 重置表单
    resetForm() {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields();
      }
    },

    // 点击树节点选择父级
    handleNodeClick(data) {
      this.dataForm.parent_id = data.id; // 可能是 null
      this.$refs.menuTree.setCurrentKey(data.id);
    },

    // 提交表单
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return;

        // 构造提交数据
        const postData = { ...this.dataForm };

        this.submitLoading = true;
        this.$axios
          .post('/api-30216/api/menu', postData)
          .then(res => {
            const responseData = res.data || res;
            if (responseData.code === 200 || responseData.success) {
              this.$message.success(responseData.message || '新增成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新
            } else {
              this.$message.error(responseData.message || '新增失败');
            }
          })
          .catch(err => {
            let msg = '新增菜单失败';
            // 替换可选链写法
            if (err.response && err.response.data && err.response.data.message) {
              msg = err.response.data.message;
            } else if (err.message) {
              msg = err.message;
            }
            this.$message.error(msg);
            console.error('提交错误：', err);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.el-tree {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 4px;
}
</style>